import Task from 'models/tasks/task';
import { getDateDiffDays, setNewDateKeepTime, setNewTimeKeepDate } from 'utils/datetime';

export const wizardDefaultDeadlineHour = 17;

//moves the deadline of the given task (a copy the caller owns) to the given day, keeping its
//time; start and end follow when the deadline would otherwise fall before the end (the task is
//not allowed to end after its deadline)
export const setWizardDeadlineDay = (copy: Task, day: Date) => {
  const time = copy.deadline ?? setNewTimeKeepDate(undefined, wizardDefaultDeadlineHour, 0);
  copy.deadline = setNewDateKeepTime(day, time);

  if (copy.deadline < copy.endDateTime) {
    copy.startDateTime = setNewDateKeepTime(day, copy.startDateTime);
    copy.endDateTime = setNewDateKeepTime(day, copy.endDateTime);

    if (copy.deadline < copy.endDateTime) {
      copy.deadline = new Date(copy.endDateTime);
    }
  }
};

//the last day of this month; when today already is that day, the last day of next month
export const getEndOfMonth = (today: Date): Date => {
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  if (getDateDiffDays(lastDay, today) === 0) {
    return new Date(today.getFullYear(), today.getMonth() + 2, 0);
  }

  return lastDay;
};
